import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'María José G.',
  role: 'Hija mayor · 42 años',
  text: 'Mi mamá lloró de emoción cuando lo recibió. Me dijo que era el regalo más hermoso de su vida. Cada tarde se sienta a escribir y descubro historias que nunca conocí. Es un tesoro.'
}, {
  name: 'Carlos M.',
  role: 'Hijo · 38 años',
  text: 'Compré el pack familiar completo. Mi mamá siempre fue reservada, pero con este libro empezó a abrirse. Mis hijos tienen las historias de su abuela escritas de su puño y letra.'
}, {
  name: 'Luciana F.',
  role: 'Hija · 35 años',
  text: 'Las preguntas son tan lindas que mi mamá (68 años) empezó a contarme historias mientras escribía. Es un regalo que nos unió más y que voy a atesorar toda mi vida.'
}, {
  name: 'Paula R.',
  role: 'Nieta · 29 años',
  text: 'Le regalamos el libro a mi abuela y hoy toda la familia lee sus recuerdos juntos. No es un libro, es un tesoro que va a vivir con nosotros para siempre.'
}];
export function Testimonials() {
  return <section className="py-16 px-4 md:px-8 bg-white" data-id="element-208">
      <div className="max-w-6xl mx-auto" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-210">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#1A1A1A] mb-12" data-id="element-211">
            Lo que dicen quienes ya lo regalaron 🤍
          </h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-212">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-orange-50 rounded-lg p-6 hover:shadow-lg transition-shadow" data-id="element-213">
                <div className="text-[#F5A623] text-xl mb-3" data-id="element-214">★★★★★</div>
                <p className="text-gray-700 italic mb-4 leading-relaxed" data-id="element-215">
                  "{testimonial.text}"
                </p>
                <div data-id="element-216">
                  <p className="font-bold text-[#1A1A1A]" data-id="element-217">{testimonial.name}</p>
                  <p className="text-sm text-gray-600" data-id="element-218">{testimonial.role}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}